import React from "react";

function MenuIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="17"
      fill="none"
      viewBox="0 0 25 17"
    >
      <path
        fill="#000"
        d="M.875 16.25h23.25v-2.583H.875v2.583zm0-6.458h23.25V7.208H.875v2.584zm0-9.042v2.583h23.25V.75H.875z"
      ></path>
    </svg>
  );
}

export default MenuIcon;
